import React from 'react'
import { Script } from 'gatsby'

// Components
import BidJsScripts from './bidJsScripts'
import Header from './header'
import Footer from './footer'

const Layout = ({ children, uid }) => {
  return (
    <div className='flex min-h-screen flex-col bg-gray-50 text-gray-800 antialiased'>
      <Header uid={uid} />
      <main role='main' id='main'>
        {children}
      </main>
      <Footer />
      <BidJsScripts uid={uid} />
      <Script
        id='hotjar'
        dangerouslySetInnerHTML={{
          __html: `
          (function(h,o,t,j,a,r) {
            h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
            h._hjSettings={hjid:${process.env.GATSBY_HOTJAR_ID},hjsv:${process.env.GATSBY_HOTJAR_SNIPPET_VERSION}};
            a=o.getElementsByTagName('head')[0];
            r=o.createElement('script');r.async=1;
            r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
            a.appendChild(r);
          })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
        `
        }}
      />
    </div>
  )
}

export default Layout
